import React from 'react';
import { Form } from "react-bootstrap";

/**Form text box functional component */
export const FormTextBox = (props) => {
    const display = {
        as: props.as || "input",
        onChange: props.textChanger,
        name: props.name,
        placeholder: props.placeholder,
        value: props.value,
        disable: props.readOnly.toString() || false,
        rows: props.rows
    };
    return props.formGroupAs ?
        <Form.Group as={props.formGroupAs}>
            <Form.Label>{props.formLabel}</Form.Label>
            <Form.Control
                {...display}
            />
        </Form.Group> :
        <Form.Group>
            <Form.Label>{props.formLabel}</Form.Label>
            <Form.Control
                {...display}
            />

        </Form.Group>;
};


// WEBPACK FOOTER //
// ./src/components/components/FormTextBox.js